export const PAGINATION_SIZE = 30;
export const MAX_PAGINATION_SIZE = PAGINATION_SIZE * 7;
